export const shouldShowUniversalProductsEmptyState = ({
  currentDataLength,
  isAnyReferenceLoading,
  somePriceMissing,
  someStockMissingFirstLoad,
  someStockMissing,
}: {
  currentDataLength: number;
  isAnyReferenceLoading: boolean;
  somePriceMissing: boolean;
  someStockMissingFirstLoad: boolean;
  someStockMissing: boolean;
}): boolean => {
  const isStillLoading = isAnyReferenceLoading || somePriceMissing || someStockMissingFirstLoad || someStockMissing;
  return currentDataLength === 0 && !isStillLoading;
};

export const getUniversalProductsDisplayCount = ({
  referencesLength,
  displayReferencesLength,
  referencesLoading,
}: {
  referencesLength: number;
  displayReferencesLength: number;
  referencesLoading: boolean;
}): number => (referencesLoading ? referencesLength : displayReferencesLength);
